// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "0749de3cec2260d8ca195ba873e24615" + ".js";
};